import './BarCompleted.scss';

export const BarCompleted = () => <div className="bar-completed" />

